export default "__VITE_ASSET___a4CRj4E__"